<template>
  <div class="txn-wrap">
    <div id="nodeType" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
import { mapState, mapActions } from 'vuex'
export default {
  name: 'TxnLine',
  data() {
    return {
      chart: null,
      intervalId: null,
      total: 0,
      option: {
        tooltip: {
          trigger: 'item'
        },
        graphic: [
          {
            type: 'rect',
            left: '10%',
            top: '20%',
            bottom: '0%',
            z: 100,
            style: {
              stroke: 'red',
              lineWidth: 2,
              fill: 'transparent',
              shadowBlur: 10,
              shadowColor: '#aaa'
            }
          }
        ],
        title: {
          text: ['节点数', '1000'].join('\n\n'),
          left: '49%',
          top: '42%',
          textAlign: 'center',
          // 可以设置显示的样式
          textStyle: {
            color: 'rgba(0,203,255)',
            fontWeight: 'normal',
            fontSize: 14
          }
        },

        series: [
          {
            name: '节点类型',
            type: 'pie',
            radius: ['70%', '60%'],
            data: []
          },
          {
            name: '外边框',
            type: 'pie',
            tooltip: {
              show: false
            },
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ['50%', '50%'], //这里跟上面那组一样即可
            radius: ['80%', '78%'], //这里根据自己的需要自行调整，但是两个值要一样大哦，如果小于上方设置的最小内圆30%则为内阴影，大于外圆60%则为外阴影
            label: {
              normal: {
                show: false //重点：此处主要是为了不展示data中的value和name
              }
            },
            data: [
              {
                value: 1, //此处的值无所谓是多少
                name: '', //因为不展示label，可不填
                itemStyle: {
                  //边框样式，此处我们设置的浅蓝色，颜色可自行修改
                  // normal: {
                  //   borderWidth: 20, //边框宽度
                  //   borderColor: 'rgba(94, 183, 249,  0.13)' //边框颜色
                  // }
                }
              }
            ],
            itemStyle: {
              normal: {
                color: {
                  type: 'radial',
                  x: 0.5,
                  y: 0,
                  r: 0.7,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#9FB4D5' // 渐变起始颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,0,0,0)' // 渐变终止颜色
                    }
                  ],
                  globalCoord: false
                },
                label: {
                  show: true,
                  formatter: '{b} ({d}%)'
                }
              }
            }
          },
          {
            name: '外边框',
            type: 'pie',
            tooltip: {
              show: false
            },
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ['50%', '50%'], //这里跟上面那组一样即可
            radius: ['80%', '78%'], //这里根据自己的需要自行调整，但是两个值要一样大哦，如果小于上方设置的最小内圆30%则为内阴影，大于外圆60%则为外阴影
            label: {
              normal: {
                show: false //重点：此处主要是为了不展示data中的value和name
              }
            },
            data: [
              {
                value: 1, //此处的值无所谓是多少
                name: '', //因为不展示label，可不填
                itemStyle: {
                  //边框样式，此处我们设置的浅蓝色，颜色可自行修改
                  // normal: {
                  //   borderWidth: 20, //边框宽度
                  //   borderColor: 'rgba(94, 183, 249,  0.13)' //边框颜色
                  // }
                }
              }
            ],
            itemStyle: {
              normal: {
                color: {
                  type: 'radial',
                  x: 0.5,
                  y: 1,
                  r: 0.7,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#00CBFF' // 渐变起始颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,0,0,0)' // 渐变终止颜色
                    }
                  ],
                  globalCoord: false
                },
                label: {
                  show: true
                  // formatter: '{b} ({d}%)',
                  // formatter: function (params) {
                  //     console.log(params)
                  //     return '<div style="color: #333; font-weight: bold;">' + params.name + '</div>'
                  //         + '<div style="font-size: 12px;">' + params.percent.toFixed(2) + '%</div>';
                  // }
                }
              }
            }
          },
          {
            name: '外边框',
            type: 'pie',
            tooltip: {
              show: false
            },
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ['50%', '50%'], //这里跟上面那组一样即可
            radius: ['53%', '52%'], //这里根据自己的需要自行调整，但是两个值要一样大哦，如果小于上方设置的最小内圆30%则为内阴影，大于外圆60%则为外阴影
            label: {
              normal: {
                show: false //重点：此处主要是为了不展示data中的value和name
              }
            },
            data: [
              {
                value: 1,
                name: '',
                itemStyle: { color: '#C2D7FD', opacity: 0.4 }
              }
            ]
          }
        ]
      },
      consensus: {
        color: 'rgba(0,203,255,0.8)'
      },
      synchronous: {
        color: '#FECB00'
        // label: {
        //     show: true, // 显示标签
        //     formatter: '{b} ({d}%)', // 设置标签格式
        //     textStyle: {
        //         fontSize: 14, // 设置文字大小
        //         fontWeight: 'bold', // 加粗字体
        //         color: '#FECB00' // 设置文字颜色
        //     }
        // },
      }
    }
  },
  computed: {},
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },
  mounted() {
    this.initChart()
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 10000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },
  methods: {
    updateLabelLayout(params) {
      const isLeft = params.labelRect.x < this.chart.getWidth() / 2
      const points = params.labelLinePoints
      // Update the end point.
      points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width
      return {
        labelLinePoints: points
      }
    },
    getData() {
      let cid = this.$store.state.home.chainCid
      let params = {
        chain_id: cid
      }
      this.$apis.chain.getNodesInfo(params).then(res => {
        if (res.data) {
          let seriesData = []
          const labelStyle1 = {
            fontSize: 12,
            color: 'rgba(0,203,255,0.8)'
          }
          const labelStyle2 = {
            fontSize: 12,
            color: '#FECB00'
          }
          this.total = null
          res.data.nodes_info &&
            res.data.nodes_info.forEach(item => {
              const name = item.node_type === 0 ? '共识节点' : '同步节点'
              const value = item.node_num
              const itemStyle = item.node_type === 0 ? this.consensus : this.synchronous
              const labelStyle = item.node_type === 0 ? labelStyle1 : labelStyle2
              this.total += value
              if (value > 0) {
                seriesData.push({
                  name,
                  value,
                  itemStyle,
                  globalCoord: true,

                  label: {
                    alignTo: '',
                    formatter: '{b}  {c}',
                    minMargin: 5,
                    edgeDistance: 1,
                    lineHeight: 15,
                    textStyle: labelStyle
                  },
                  labelLine: {
                    length: 20,
                    length2: 10,
                    maxSurfaceAngle: 28,
                    type: 'dashed' // 设置为虚线
                  }
                })
              }
            })
          this.chart.setOption({
            series: [
              {
                data: seriesData
              }
            ],
            title: {
              text: ['节点数', this.total].join('\n\n') // join('\n')作用是换行居中
            }
          })
        }
      })
    },
    initChart() {
      let container = document.getElementById('nodeType')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.txn-wrap {
  @include px2vw(height, 240);
}

.line-chart {
  @include px2vw(width, 350);
  @include px2vw(height, 240);
}
</style>
